const LAYOUT = 'AdsLayout';

export const AsDeporteRouter = [
  {
    path: '/asdeporte',
    name: 'AsdRoot',
    component: () => import('../../views/asdeporte/Events'),
    meta: { layout: LAYOUT }
  },
  {
    path: '/asdeporte/contact',
    name: 'AsdContact',
    component: () => import('../../views/Contact'),
    meta: { layout: LAYOUT }
  },
  {
    path: '/asdeporte/events',
    name: 'AsdEvents',
    component: () => import('../../views/asdeporte/Events'),
    meta: { layout: LAYOUT }
  },
  {
    path: '/asdeporte/events/:id',
    name: 'AsdEvent',
    component: () => import('../../views/events/Show'),
    meta: { layout: LAYOUT }
  }
];